/* Header search suggestions: shows matching products after 3+ characters.
   Uses Shopify's Predictive Search API + Section Rendering (sections/predictive-search.liquid). */
(function () {
  'use strict';
  var MIN_CHARS = 3;
  var panel = document.getElementById('SearchPanel');
  if (!panel) return;
  var input = panel.querySelector('input[type="search"]');
  var results = panel.querySelector('[data-predictive]');
  if (!input || !results) return;

  var timer = null;
  var controller = null;
  var cache = {};
  var active = -1;

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-controls', results.id);
  input.setAttribute('aria-expanded', 'false');

  function close() {
    results.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    active = -1;
  }

  function show(html) {
    results.innerHTML = html;
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    active = -1;
  }

  function fetchSuggestions(q) {
    if (cache[q]) { show(cache[q]); return; }
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    var url = (window.theme && window.theme.routes && window.theme.routes.root || '/').replace(/\/$/, '') +
      '/search/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last' +
      '&section_id=predictive-search';
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var inner = doc.querySelector('.predictive__inner');
        var html = inner ? inner.outerHTML : '';
        cache[q] = html;
        if (input.value.trim() === q && html) show(html);
      })
      .catch(function (e) { if (e.name !== 'AbortError') close(); });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < MIN_CHARS) { close(); return; }
    timer = setTimeout(function () { fetchSuggestions(q); }, 220);
  });

  input.addEventListener('focus', function () {
    var q = input.value.trim();
    if (q.length >= MIN_CHARS && cache[q]) show(cache[q]);
  });

  // Arrow keys move through the suggestions, Enter opens the highlighted one.
  input.addEventListener('keydown', function (e) {
    if (results.hidden) return;
    var options = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!options.length) return;
      e.preventDefault();
      active = e.key === 'ArrowDown' ? (active + 1) % options.length : (active - 1 + options.length) % options.length;
      options.forEach(function (o, i) { o.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
      options[active].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && active >= 0 && options[active]) {
      e.preventDefault();
      window.location.href = options[active].querySelector('a').href;
    } else if (e.key === 'Escape') {
      close();
    }
  });

  document.addEventListener('click', function (e) {
    if (!panel.contains(e.target)) close();
  });
})();
